import {Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Home'
    },
  }
];

